import React from "react";
// import './css/codeEditor.css';
import copy_icon from "../../data/images/img-copy.png";


const CodeView = (props) => {
  const Copy_btn = () => {
    // Copy to Clipbord Button
    // console.log("button Display clicked");
    var input = document.createElement('input');
    // var value  = this.state.open_topic.cells[index].source;
    var value  = props.data.d.source;
    input.setAttribute('value', value);
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand('copy');
    document.body.removeChild(input);
    return result;
};

  return (
    <div className="img_view">
      <div className="img_content">
          {props.data.d.cell_layout.img_format === "http" ? <img src={props.data.d.source} alt="Apple logo"/>:<td dangerouslySetInnerHTML={{__html: props.data.d.source}} />}
      </div>
      <button className="copy_button" onClick={Copy_btn.bind()}>
          <span class="copy-tooltip">Copy Img</span>
          <img className="copy_icon" src={copy_icon}></img>
      </button>
    </div>
  );
};

export default CodeView;